'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var elementType = {};

exports.__exports = elementType;
